// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
//import { getAnalytics } from "firebase/analytics";
import { browserLocalPersistence,initializeAuth  } from "firebase/auth";
//import { getFirestore } from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

const firebaseConfig = {
  apiKey: "AIzaSyC8ueOT-avmcL-DYlH-HwmQP04Q_DjP7Us",
  authDomain: "hostelmanagement-ef900.firebaseapp.com",
  projectId: "hostelmanagement-ef900",
  storageBucket: "hostelmanagement-ef900.appspot.com",
  messagingSenderId: "162757811535",
  appId: "1:162757811535:web:992b5e381420011b6df93a",
  measurementId: "G-PE57DEH672"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = initializeAuth(app, {
  persistence: browserLocalPersistence
});
//const db = getFirestore(app);
export {app,auth,firebaseConfig}